import React from 'react';
import { ACL_RESOURCE_TYPE_CREDENTIALS } from 'js/constants/aclConstants';
import AclTabViewContainer from 'js/components/elements/aclView/AclTabViewContainer';
import CredentialOverviewTabContainer from 'js/components/credentials/cards/CredentialOverviewTabContainer';
import { CredentialUsage } from '../components/CredentialUsage/CredentialUsage';

export interface CredentialTabConfig {
  tabName: string;
  tabElement: any;
  value?: string;
  label?: string;
}

const OVERVIEW_TAB: CredentialTabConfig = {
  tabName: 'Overview',
  tabElement: <CredentialOverviewTabContainer />,
  value: 'overview',
  label: 'Overview',
};

const USAGE_TAB: CredentialTabConfig = {
  tabName: 'Usage',
  tabElement: <CredentialUsage />,
  value: 'usage',
  label: 'Usage',
};

const ACCESS_TAB: CredentialTabConfig = {
  tabName: 'Access',
  tabElement: <AclTabViewContainer resourceType={ACL_RESOURCE_TYPE_CREDENTIALS} />,
  value: 'access',
  label: 'Access',
};

/**
 * Create the credential tab configs.
 * By default, the Overview, Usage and Access tabs are included.
 * You can pass in the options to include or exclude the tabs.
 * @param options
 */
interface Options {
  includeUsage?: boolean;
  includeAccess?: boolean;
  includeActivity?: boolean;
}
export function createCredentialTabConfigs(options?: Options): CredentialTabConfig[] {
  const { includeUsage = true, includeAccess = true } = options || {};
  const tabs: CredentialTabConfig[] = [OVERVIEW_TAB];

  if (includeUsage) {
    tabs.push(USAGE_TAB);
  }

  if (includeAccess) {
    tabs.push(ACCESS_TAB);
  }

  return tabs;
}
